import Main from './views/auth/Main'
import CreateAccount from './views/auth/CreateAccount'
import ResumeEnrollment from './views/auth/ResumeEnrollment'
import userInfo from './components/userInfo/userInfo'
import editUserInfo from './components/userInfo/editUserInfo'

export const routes = [
    {
        path: '/home',
        name: 'AuthMain',
        component: Main
    },
    {
        path: '/create-account',
        name: 'CreateAccount',
        component: CreateAccount
    },
    {
        path: '/resume-enrollment',
        name: 'ResumeEnrollment',
        component: ResumeEnrollment
    },
    {
        path: '/user-info',
        name: 'userInfo',
        component: userInfo
    },
    {
        path: '/edit-user-info',
        name: 'editUserInfo',
        component: editUserInfo
    },
];